// Feature flags configuration
// Use environment variables to control feature visibility

export enum FlagPages {
  USERS_PAGE = 'USERS_PAGE',
  UNBALANCE_PAGE = 'UNBALANCE_PAGE',
  MAP_PAGE = 'MAP_PAGE',
  ADMINISTRATION_PAGE = 'ADMINISTRATION_PAGE',
  RESTRICTIONS_JOURNAL_PAGE = 'RESTRICTIONS_JOURNAL_PAGE',
}

// Hidden features that can be re-enabled with feature flags
const FEATURE_FLAGS = {
  [FlagPages.USERS_PAGE]: process.env.REACT_APP_FEATURE_USERS === 'true' || false,
  [FlagPages.UNBALANCE_PAGE]: process.env.REACT_APP_FEATURE_UNBALANCE === 'true' || false,
  [FlagPages.MAP_PAGE]: process.env.REACT_APP_FEATURE_MAP === 'true' || false,
  [FlagPages.ADMINISTRATION_PAGE]: process.env.REACT_APP_FEATURE_ADMINISTRATION === 'true' || false,
  [FlagPages.RESTRICTIONS_JOURNAL_PAGE]:
    process.env.REACT_APP_FEATURE_RESTRICTIONS_JOURNAL === 'true' || false,
} as const

type FeatureName = keyof typeof FEATURE_FLAGS

// Helper function to check if feature is enabled
export const isFeatureEnabled = (featureName: FeatureName): boolean =>
  FEATURE_FLAGS[featureName] || false

// Helper function to check if API endpoint should be available
export const isApiEndpointEnabled = (featureName: FeatureName): boolean =>
  isFeatureEnabled(featureName)

// Helper function to get permissions based on feature flag
export function getFeaturePermissions<T>(featureName: FeatureName, permissions: T[]): T[] {
  return permissions.filter(() => isFeatureEnabled(featureName))
}

export default FEATURE_FLAGS
